import styled from "@emotion/styled";
import { fontMerriweather, fontRoboto, theme } from "@product/scmp-sdk";

import Preview from "scmp-app/components/newsletter/newsletter-list/newsletter-category-item-list/newsletter-item-card/preview.svg";

export const EyeIcon = styled(Preview)`
  position: absolute;
  inset-inline-end: 16px;
`;

export const Container = styled.div<{ $isFocused: boolean }>`
  margin-inline-end: 40px;

  transition: transform 0.3s;
  animation: fadeIn 0.2s linear;

  ${theme.breakpoints.only("tablet")} {
    margin-inline-end: 39px;
  }

  ${theme.breakpoints.only("mobile")} {
    margin-inline-end: 30px;
  }
  ${({ $isFocused }) =>
    $isFocused &&
    `
    ${theme.breakpoints.not("mobile")} {
      transform: translate3d(7px, 0, 0);
    }
  `}
`;

export const Wrapper = styled.div<{ $isFocused: boolean }>`
  position: relative;

  display: inline-flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  inline-size: 100%;
  margin-block-end: 28px;
  padding: 16px;
  box-sizing: content-box;

  background: #f7f7f7;

  ${theme.breakpoints.only("mobile")} {
    ${EyeIcon} {
      display: block !important;
    }
  }

  ${EyeIcon} {
    display: ${({ $isFocused }) => ($isFocused ? "none" : "block")};
  }

  ${({ $isFocused }) =>
    $isFocused &&
    `
    background: #ECF3FF;
  `}
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const Frequency = styled.div`
  color: #001246;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: 14px;
  text-transform: uppercase;
`;

export const Title = styled.div`
  color: #001246;
  font-size: 21px;
  font-family: ${fontMerriweather};
  line-height: 27px;
`;

export const Description = styled.div`
  color: #001246;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 18px;
`;

export const SetupBox = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  inline-size: 100%;
  padding: 10px;

  border: 1px solid #4585ff;
`;

export const SetupBoxText = styled.div`
  color: #4585ff;
  font-size: 12px;
  font-family: ${fontRoboto};
  line-height: normal;
`;

export const SetupBoxButton = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;

  padding: 8px;

  white-space: nowrap;

  border-radius: 2px;

  background: #4585ff;

  cursor: pointer;
`;

export const SetupBoxButtonText = styled.div`
  color: #ffffff;
  font-size: 12px;
  font-family: ${fontRoboto};
`;
